import { ErrorMessage, Heading, InfoIcon, Input, Layout, RadioButton } from "@vwfs-bronson/bronson-react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { IMatchMakerAnswers } from "../../interfaces";
import { BrandType } from "@bus/models";

export const Deposit = () => {
    const brand = process.env.REACT_APP_WEBSITE_BRAND;
    const { t } = useTranslation(["question2page"]);
    const { values, setFieldValue, errors, getFieldProps, touched } = useFormikContext<IMatchMakerAnswers>();
    const handleChangeInputNumber = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!event.target.value) {
            setFieldValue("deposit", "", true);
        } else if (isNaN(Number(event.target.value))) {
            return;
        } else {
            setFieldValue("deposit", parseFloat(event.target.value), true);
        }
    };

    const getTitle = () => {
        switch (brand) {
            case BrandType.VW:
            case BrandType.AUDI:
                return t("question2page:deposit.titleAlternative")
            default:
                return t("question2page:deposit.title");
        }
    }
    
    return (
        <>
            <Heading level={2} className="u-font-size-fs2">
                {getTitle()}
                <InfoIcon icon="semantic-info" className="u-ml-xsmall" aria-label={t("question2page:deposit.tooltip")}>
                    {t("question2page:deposit.tooltip")}
                </InfoIcon>
            </Heading>
            <Layout>
                <Layout.Item default="1/3">
                    <RadioButton
                        aria-invalid={!!(touched["deposit"] && errors["deposit"])}
                        aria-errormessage={`monthlyPayment`}
                        name="hasDeposit"
                        onChange={() => setFieldValue("hasDeposit", false)}
                        checked={!values.hasDeposit || false}
                    >
                        {t("question2page:deposit.options.no")}
                    </RadioButton>
                </Layout.Item>
                <Layout.Item default="1/3">
                    <RadioButton
                        name="hasDeposit"
                        onChange={() => setFieldValue("hasDeposit", true)}
                        checked={values.hasDeposit || false}
                    >
                        {t("question2page:deposit.options.yes")}
                    </RadioButton>
                </Layout.Item>
                {values.hasDeposit && (
                    <Layout.Item>
                        <Input
                            addonText="€"
                            {...getFieldProps("deposit")}
                            type="text"
                            pattern="[0-9]*"
                            inputMode="numeric"
                            id="deposit"
                            noBackground
                            onChange={handleChangeInputNumber}
                            required
                            aria-labelledby={`monthlyPayment`}
                        />
                    </Layout.Item>
                )}
            </Layout>
            {touched["deposit"] && errors["deposit"] && (
                <Layout>
                    <Layout.Item>
                        <ErrorMessage id={`monthlyPayment`}>{errors["deposit"] || ("" as string)}</ErrorMessage>
                    </Layout.Item>
                </Layout>
            )}
        </>
    );
};
